import { FormBase } from "../../../util/form-base-form";

class SearchUserModalForm extends FormBase {
    public getOverlay(root: ParentNode, role: string): HTMLElement | null {
        return this.queryElement(root, `[data-role="${role}"]`, HTMLElement);
    }

    public getModal(root: ParentNode, role: string): HTMLElement | null {
        return this.queryElement(root, `[data-role="${role}"]`, HTMLElement);
    }

    public getListRoot(root: ParentNode, role: string): HTMLElement | null {
        return this.queryElement(root, `[data-role="${role}"]`, HTMLElement);
    }

    public getCloseButton(root: ParentNode, role: string): HTMLElement | null {
        return this.queryElement(root, `[data-role="${role}"]`, HTMLElement);
    }

    public getFilterInput(root: ParentNode, role: string): HTMLInputElement | null {
        return this.getInput(root, `[data-role="${role}"]`);
    }
}

const searchUserModalForm = new SearchUserModalForm();

export { SearchUserModalForm, searchUserModalForm };
